<template>
    <BCard no-body class="mb-0">
        <TableFilters :vsPerPage="perPage" :vsPageOptions="perPageOptions" :vsSearchQuery="searchQuery" vsLabel="Add discount" vsModule="discount" vsRoute="discounts-add" />

        <BTable ref="discountTable" class="position-relative" :items="fetchDiscount" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No match records found')" :sort-desc.sync="isSortDirDesc">
            <template #cell(name)="data">
                <BLink :to="{ name: 'discounts-view', params: { id: data.item.id } }"> {{ data.item.name }} </BLink>
            </template>
            <template #cell(value)="data">
                {{ data.item.type == "percentage" ? data.item.value + " % " : data.item.value + " € " }}
            </template>
            <template #cell(item_type)="data">
                {{ resolveItemType(data.item.item_type) }}
            </template>
            <template #cell(item)="data">
                {{ data.item.item ? data.item.item.name : '-' }}
            </template>
            <template #cell(status)="data">
                <BBadge pill variant="light-success" class="text-capitalize" v-if="data.item.status"> {{ $t('Active') }} </BBadge>
                <BBadge pill variant="light-danger" class="text-capitalize" v-else> {{ $t('Inactive') }} </BBadge>
            </template>
            <template #cell(actions)="data">
                <BDropdown variant="link" no-caret>
                    <template #button-content>
                        <FeatherIcon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                    </template>
                    <BDropdownItem :to="{ name: 'discounts-view', params: { id: data.item.id } }" v-if="ability.can('read', 'discount')">
                        <FeatherIcon icon="FileTextIcon" />
                        <span class="align-middle ml-50">{{$t('Details')}}</span>
                    </BDropdownItem>

                    <BDropdownItem :to="{ name: 'discounts-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'discount')">
                        <FeatherIcon icon="EditIcon" />
                        <span class="align-middle ml-50">{{$t('Edit')}}</span>
                    </BDropdownItem>

                    <BDropdownItem @click="deletePopup(data.item.id, 'discounts/deleteDiscount')" v-if="ability.can('delete', 'discount')">
                        <FeatherIcon icon="TrashIcon" />
                        <span class="align-middle ml-50">{{$t('Delete')}}</span>
                    </BDropdownItem>
                </BDropdown>
            </template>
        </BTable>

        <TablePagination :vsEntries="dataMeta" :vsCurrent="currentPage" :vsPerPage="perPage" :vsTotal="totalDiscount" />
    </BCard>
</template>
<script>
import { BBadge, BCard, BDropdown, BDropdownItem, BLink, BRow, BTable } from 'bootstrap-vue';
import { onUnmounted } from '@vue/composition-api';
import TablePagination from '@/components/list/TablePagination.vue';
import TableFilters from '@/components/list/TableFilters.vue';
import discountListQuery from './discountListQuery';
import ability from '@/libs/acl/ability';
import discountModule from '../discountModule';
import popups from '@/hooks/popups';
import store from '@/store';
import i18n from '@/libs/i18n';

export default {
    components: { BCard, BRow, TablePagination, TableFilters, BTable, BLink, BDropdown, BDropdownItem, BBadge },
    setup(){
        const { deletePopup } = popups()
        const { fetchDiscount, tableColumns, perPage, currentPage, totalDiscount, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, discountTable, refetchData, groupFilter, groupOptions } = discountListQuery()
        const DISCOUNT_MODULE = 'discounts'

        if(!store.hasModule(DISCOUNT_MODULE)){
            store.registerModule(DISCOUNT_MODULE, discountModule)
        }

        onUnmounted(() => {
            if(store.hasModule(DISCOUNT_MODULE)) {
                store.unregisterModule(DISCOUNT_MODULE)
            }
        })

        const resolveItemType = function(type) {
            if(type == 'family') return 'Familia de producto'
            if(type == 'section') return 'Sección de curso'
            if(type == 'products') return 'Productos'
            if(type == 'quota') return 'Mensualidad'
            if(type == 'product') return 'Producto'
            if(type == 'courses') return 'Cursos'
            if(type == 'course') return 'Curso'
            if(type == 'all') return 'Todos'
        }

        return {
            resolveItemType,
            fetchDiscount,
            tableColumns,
            perPage,
            currentPage,
            totalDiscount,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            discountTable,
            refetchData,
            groupFilter,
            groupOptions,
            ability,
            deletePopup,
        }
    }
}
</script>
